import { RSAA } from 'redux-api-middleware';
import TELEMETRY_API from '../../config/api';

export const PATIENT_ADVOCATES_REQUEST = 'PATIENT_ADVOCATES_REQUEST';
export const PATIENT_ADVOCATES_SUCCESS = 'PATIENT_ADVOCATES_SUCCESS';
export const PATIENT_ADVOCATES_FAILURE = 'PATIENT_ADVOCATES_FAILURE';

export const EMPLOYERS_TYPEAHEAD_REQUEST = 'EMPLOYERS_TYPEAHEAD_REQUEST';
export const EMPLOYERS_TYPEAHEAD_SUCCESS = 'EMPLOYERS_TYPEAHEAD_SUCCESS';
export const EMPLOYERS_TYPEAHEAD_FAILURE = 'EMPLOYERS_TYPEAHEAD_FAILURE';

export const LOCATIONS_TYPEAHEAD_REQUEST = 'LOCATIONS_TYPEAHEAD_REQUEST';
export const LOCATIONS_TYPEAHEAD_SUCCESS = 'LOCATIONS_TYPEAHEAD_SUCCESS';
export const LOCATIONS_TYPEAHEAD_FAILURE = 'LOCATIONS_TYPEAHEAD_FAILURE';

export const ADD_ACTION_REQUEST = 'ADD_ACTION_REQUEST';
export const ADD_ACTION_SUCCESS = 'ADD_ACTION_SUCCESS';
export const ADD_ACTION_FAILURE = 'ADD_ACTION_FAILURE';

export const ADVOCATE_REQUEST = 'ADVOCATE_REQUEST';
export const ADVOCATE_SUCCESS = 'ADVOCATE_SUCCESS';
export const ADVOCATE_FAILURE = 'ADVOCATE_FAILURE';

export const AUDIT_LOG_REQUEST = 'AUDIT_LOG_REQUEST';
export const AUDIT_LOG_SUCCESS = 'AUDIT_LOG_SUCCESS';
export const AUDIT_LOG_FAILURE = 'AUDIT_LOG_FAILURE';

export const ADVOCATE_QUERY_REQUEST = 'ADVOCATE_QUERY_REQUEST';
export const ADVOCATE_QUERY_SUCCESS = 'ADVOCATE_QUERY_SUCCESS';
export const ADVOCATE_QUERY_FAILURE = 'ADVOCATE_QUERY_FAILURE';

export const SET_VIEW = 'SET_VIEW';

export function requestPatientAdvocates(params = {}) {
  const query = $.param(params, true);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/advocate/patients/search?${query}`,
      method: 'GET',
      types: [
        'PATIENT_ADVOCATES_REQUEST',
        'PATIENT_ADVOCATES_SUCCESS',
        'PATIENT_ADVOCATES_FAILURE',
      ],
    },
  };
}

export function requestActions(visitNoteID, params = {}) {
  const query = $.param({ ...params, order: 'asc createdAt' });
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinic/visit-notes/${visitNoteID}/actions?${query}`,
      method: 'GET',
      types: [
        { type: 'ACTIONS_REQUEST', meta: { visitNoteID } },
        { type: 'ACTIONS_SUCCESS', meta: { visitNoteID } },
        'ACTIONS_FAILURE',
      ],
    },
  };
}

export function addAction(visitNoteID, data, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/clinic/visit-notes/${visitNoteID}/actions?${query}`,
      method: 'POST',
      body: JSON.stringify(data),
      types: ['ADD_ACTION_REQUEST', 'ADD_ACTION_SUCCESS', 'ADD_ACTION_FAILURE'],
    },
  };
}

export function setView(view) {
  return dispatch => {
    return dispatch({
      type: SET_VIEW,
      view,
    });
  };
}

export function requestAdvocate(patientID, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/advocate/patients/${patientID}?${query}`,
      method: 'GET',
      types: [
        { type: 'ADVOCATE_REQUEST', meta: { patientID } },
        { type: 'ADVOCATE_SUCCESS', meta: { patientID } },
        'ADVOCATE_FAILURE',
      ],
    },
  };
}

export function requestEmployersTypeahead(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/advocate/employers/typeahead?${query}`,
      method: 'GET',
      types: ['EMPLOYERS_TYPEAHEAD_REQUEST', 'EMPLOYERS_TYPEAHEAD_SUCCESS', 'EMPLOYERS_TYPEAHEAD_FAILURE']
    }
  };
}

export function requestLocationsTypeahead(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/advocate/locations/typeahead?${query}`,
      method: 'GET',
      types: ['LOCATIONS_TYPEAHEAD_REQUEST', 'LOCATIONS_TYPEAHEAD_SUCCESS', 'LOCATIONS_TYPEAHEAD_FAILURE']
    }
  };
}

export function requestFiltersTypeahead(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/advocate/filters/typeahead?${query}`,
      method: 'GET',
      types: ['FILTERS_TYPEAHEAD_REQUEST', 'FILTERS_TYPEAHEAD_SUCCESS', 'FILTERS_TYPEAHEAD_FAILURE']
    }
  };
}

export function requestExportPatientAdvocate(params) {
  const query = $.param(params, true);

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/advocate/patients/export?${query}`,
      method: 'GET',
      headers: {},
      types: [
        'DOWNLOAD_FILE_REQUEST',
        {
          type: 'DOWNLOAD_FILE_SUCCESS',
          payload: (action, state, res) => {
            return res.blob();
          }
        },
        'DOWNLOAD_FILE_FAILURE']
    },
  };
}

export function importOutreachData(params, htmlFiles = []) {
  const query = $.param(params);
  const data = new FormData();

  htmlFiles.forEach((file) => data.append('file', file));

  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/advocate/outreach/import?${query}`,
      method: 'POST',
      headers: {},
      body: data,
      types: ['IMPORT_REQUEST', 'IMPORT_SUCCESS', 'IMPORT_FAILURE']
    },
  };
}

export function requestAdvocateQuery(params = {}) {
  const query = $.param(params, true);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/advocate/queries?${query}`,
      method: 'GET',
      types: ["ADVOCATE_QUERY_REQUEST", "ADVOCATE_QUERY_SUCCESS", "ADVOCATE_QUERY_FAILURE"]
    }
  }
}

export function saveAdvocateQuery(params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/advocate/queries?${query}`,
      method: 'POST',
      types: ["ADVOCATE_QUERY_SAVE_REQUEST", "ADVOCATE_QUERY_SAVE_SUCCESS", "ADVOCATE_QUERY_SAVE_FAILURE"]
    }
  }
}

export function updateAdvocateQuery(queryId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/advocate/queries/${queryId}?${query}`,
      method: 'PUT',
      types: ["ADVOCATE_QUERY_UPDATE_REQUEST", "ADVOCATE_QUERY_UPDATE_SUCCESS", "ADVOCATE_QUERY_UPDATE_FAILURE"]
    }
  }
}

export function deleteAdvocateQuery(queryId, params = {}) {
  const query = $.param(params);
  return {
    [RSAA]: {
      endpoint: `${TELEMETRY_API}organization/advocate/queries/${queryId}?${query}`,
      method: 'DELETE',
      types: ["ADVOCATE_QUERY_DELETE_REQUEST", "ADVOCATE_QUERY_DELETE_SUCCESS", "ADVOCATE_QUERY_DELETE_FAILURE"]
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/advocate-dashboard/AdvocateActions.js